$('.js-btn-modal').fancybox({
	'padding': 0,
	'overlayColor': '#13387d',
})